<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      breadcrumb: {
        name: 'Pickups',
        route: { name: 'customerservice-pickups' }
      }
    }
  }
}
</script>
